enum DOCUMENT_TYPE {
  ID_CARD = 'ID_CARD',
  BANK_ACCOUNT = 'BANK_ACCOUNT',
  RECEIPT = 'RECEIPT',
  MED_CERT = 'MED_CERT',
  OTHER = 'OTHER',
}

enum HealthClaimModeEnum {
  VIEW = 'view',
  CREATE = 'create',
  EDIT = 'edit',
}

enum ClaimChannelEnum {
  SUPERAPP = 'SUPERAPP',
  BACKOFFICE = 'BACKOFFICE',
}

// Max size for a single claim-document upload (500 MB, decimal — matches the size
// users see in Finder/OS file managers).
const MAX_CLAIM_DOCUMENT_SIZE_BYTES = 500 * 1000 * 1000

export { DOCUMENT_TYPE, HealthClaimModeEnum, ClaimChannelEnum, MAX_CLAIM_DOCUMENT_SIZE_BYTES }
